import script from "./gift-card-toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./gift-card-toggle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__